<template>
  <div class="partners">
    <Helmet>
      <title>Global Network Connectivity Business Collaboration</title>
      <meta name="title" content="Global Network Connectivity Business Collaboration" />
      <meta property="og:title" content="Global Network Connectivity Business Collaboration" />
      <meta property="twitter:title" content="Global Network Connectivity Business Collaboration" />
      <meta name="description" content="We are looking for a business partner to collaborate with our business and enhance our portfolio of global network connectivity services everywhere in the world." />
      <meta property="og:description" content="We are looking for a business partner to collaborate with our business and enhance our portfolio of global network connectivity services everywhere in the world." />
      <meta property="twitter:description" content="We are looking for a business partner to collaborate with our business and enhance our portfolio of global network connectivity services everywhere in the world." />
      <link rel="canonical" href="https://www.inte-qt.com/partner-center" />
      <meta property="og:url" content="https://www.inte-qt.com/partner-center" />
      <meta property="twitter:url" content="https://www.bitsnbyteglobal.com/partner-center" />
      <meta name="keywords" content="global business partner, business collaboration, global network connectivity, network connectivity services" />
    </Helmet>

    <img src="/images/5Q7OgtF.jpg" alt="1" class="partners__img" />

    <h1 class="center-header text-center mx-auto partners__title">
      Become a Partner in Global Network Connectivity Solutions
    </h1>

    <div class="container partners__writer">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <p align="justify">
            Collaboration is the core of our business and to enhance our portfolio of services everywhere in the world, it is important to have more and more partners, and the right partners. We aim to partner with every local and global supplier with their set of qualities to deliver a wide range of solutions to our customers.
          </p>
        </div>

        <div class="col-lg-6 col-md-12 partners__box">
          <p align="justify">
            We tend to create a mix of our services and our partner services for our customers on our portal to deliver end to end, quote to cash to assurance for any Global internet connectivity solutions, managed services and networking solutions.
          </p>
        </div>
      </div>
    </div>

    <div class="text-center container mt-5">
      <div class="b_read">
        <p class="partners__center">
          "We are enhancing our partner portfolio and our team is constantly looking for the providers offering Internet connectivity, managed services and networking solutions" <br /> GPM Head, inte-QT
        </p>
      </div>
    </div>

    <h2 class="center-header text-center mx-auto partners__title">
      Key Benefits of Partnering with Us
    </h2>
    <PartnerBenefits />

    <h2 class="center-header text-center mx-auto partners__title">
      Our Partner Program & Opportunities
    </h2>
    <PartnerTimeline />

    <div class="text-center partners__contact">
      <h2 class="center-header partners__contact-title mx-auto">
        Get in Touch to Become a Partner
      </h2>
      <router-link class="button m-4" to="/contact/partners">
        Contact Now
      </router-link>
    </div>

    <TestimonialCarousel />

    <GetInTouch />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import PartnerTimeline from '@/components/PartnerTimeline.vue';
import PartnerBenefits from '@/components/PartnerBenefits.vue';
import TestimonialCarousel from '@/components/TestimonialCarousel.vue';
import GetInTouch from '@/components/GetInTouch.vue';
import { Helmet } from 'vue-helmet';

onMounted(() => {
  window.scrollTo(0, 0);
});
</script>

<style scoped>
.partners {
  color: #000;
}

.partners__writer {
  color: #000;
}

.partners__img {
  height: 112vh;
  width: 100vw;
  object-fit: cover;
  margin-top: -60px;
  object-position: center -530px;
  filter: drop-shadow(1px 10px 40px rgb(214, 212, 212));
}

@media (max-width: 1440px) {
  .partners__img {
    object-position: center -400px;
  }
}

@media (max-width: 1200px) {
  .partners__img {
    object-position: center -380px;
    height: 92vh;
  }

  .partners__box {
    margin-left: 0rem;
    width: 550px;
  }
}

@media (max-width: 991px) {
  .partners__img {
    object-position: center -370px;
    margin-top: 5rem;
    height: 100vh;
   
  }

  .partners__header {
    font-size: 2rem;
    width: auto;
    top: 140px;
  }

  .partners__contact {
    margin: 5rem 0;
  }

  .partners__contact-title {
    margin: 3rem 0;
  }
}

@media (max-width: 768px) {
  .partners__img {
    object-position: center -200px;
    margin-top: 5rem;
    height: 37vh;
  }
}

@media (max-width: 480px) {
  .partners__img {
    object-position: center -100px;
    margin-top: 5rem;
    height: 27vh;
  }
}

.partners__center {
  font-size: 1.5rem;
  font-weight: 700;
}

.partners___box {
    margin-left: 6.5rem;
    width: 550px;

    breakpoint-down(large) {
      margin-left: 0rem;
    }
  }

.partners__header {
  position: absolute;
  width: 1300px;
  top: 18vh;
  left: 16vw;
  line-height: 1.5;
  font-size: 4.5rem;
  font-weight: 700;
}

.partners__title {
  margin: 10vh 0;
}

.partners__author {
  margin-left: 4rem;
}

.partners__contact {
  margin: 10vh;
}

.partners__contact-title {
  margin: 7rem 0;
}
</style>
